import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  MdPhone,
  MdEmail,
  MdVisibility,
  MdVisibilityOff,
  MdClose
} from "react-icons/md";






import logo from "../asset/logowhite.png";
import loginbg from "../asset/login/login.png";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SummaryApi from "../common";
import { FaArrowLeft } from "react-icons/fa";
const StudentCreate = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    mobile_number: "",
    email: "",
    password: "",
    confirm_password: "",
    is_self_registered: "1",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "mobile_number") {
      if (!/^\d*$/.test(value)) return;
      if (value.length > 10) return;
    }
    setFormData({ ...formData, [name]: value });
  };

  // --- SMS SENDING FUNCTION ---
  const sendSmsOtp = async (mobileNumber, otpValue) => {
    // We use the OTP returned from the backend, we do NOT generate a new one here

    // Construct the URL with the provided details
    const smsUrl = `https://sms.nettyfish.com/api/v2/SendSMS?SenderId=OAKYA&TemplateId=1707173313269381321&Message=Dear%20User%20your%20OTP%20${otpValue}%20for%20accessing%20admin%20panel%20-Oakya&PrincipleEntityId=1701172795416066262&ApiKey=ktTxImpILf3IA3lAdLt3sxLwpf0GUx41h9y%2BhU1LaWU=&ClientId=12eae6c0-7738-4f2a-afbe-77888ae20d0f&MobileNumbers=${mobileNumber}`;

    try {
      // mode: 'no-cors' is required because browsers block cross-origin requests to SMS gateways
      await fetch(smsUrl, {
        method: "GET",
        mode: "no-cors",
      });
      console.log("SMS Request Sent");
      return true;
    } catch (error) {
      console.error("SMS Error", error);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    // --- Validations ---
    if (!formData.first_name.trim())
      newErrors.first_name = "First name is required";
    if (!formData.last_name.trim())
      newErrors.last_name = "Last name is required";
    if (!formData.mobile_number) {
      newErrors.mobile_number = "Mobile number is required";
    } else if (!/^\d{10}$/.test(formData.mobile_number)) {
      newErrors.mobile_number = "Mobile number must be exactly 10 digits";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!formData.email.includes("@")) {
      newErrors.email = "Email must contain '@'";
    }
    if (!formData.password.trim()) newErrors.password = "Password is required";
    if (!formData.confirm_password.trim()) {
      newErrors.confirm_password = "Confirm password is required";
    } else if (formData.password !== formData.confirm_password) {
      newErrors.password = "Passwords do not match";
      newErrors.confirm_password = "Passwords do not match";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setIsLoading(true);

    try {
      const res = await fetch(SummaryApi.createStudent.url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, is_active: "1" }),
      });

      const data = await res.json();

      if (data.status === false) {
        toast.error(data?.message || "Registration failed");
        setIsLoading(false);
        return;
      }

      if (res.ok && data.status !== false) {
        // 1. Save Identifier
        localStorage.setItem("student_identifier", formData.email);

        // 2. Get OTP from Backend Response
        // NOTE: Your backend MUST return the "otp" field in the JSON response
        const backendOtp = data.otp;

        if (backendOtp) {
          // 3. Send SMS from Frontend
          await sendSmsOtp(formData.mobile_number, backendOtp);
          toast.success(`OTP sent to mobile: ${formData.mobile_number} Please go through that` );
        } else {
          toast.warning(
            "Student created, but OTP was not received from server."
          );
        }

        // 4. Navigate
        setTimeout(() => navigate("/Student-otp"), 1500);

        // 5. Reset Form
        setFormData({
          first_name: "",
          last_name: "",
          mobile_number: "",
          email: "",
          password: "",
          confirm_password: "",
          is_self_registered: "1",
        });
      } else {
        toast.error(data?.message || "Failed to create student");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full bg-white flex items-center justify-center p-4 sm:p-6">
              <button
          onClick={() => window.history.back()}
          className="fixed top-5 left-4 z-50 flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-lg hover:shadow-xl transition-all border border-gray-200 dark:bg-gray-800 dark:border-gray-700"
          aria-label="Go back"
        >
          <FaArrowLeft className="text-2xl text-[#103b6b] dark:text-white" />
        </button>

      <div className="w-full max-w-7xl min-h-[650px] flex flex-col lg:flex-row rounded-3xl overflow-hidden shadow-lg">
        {/* Left Side */}
        <div className="w-full lg:w-1/2 relative min-h-[300px] lg:min-h-auto">
          <img
            src={loginbg}
            alt="Student Background"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30" />
          <div className="relative z-10 flex items-center justify-center h-full">
            <div
              onClick={() => navigate("/", { replace: true })}
              className="cursor-pointer transition-transform duration-200 hover:scale-105"
            >
              <img src={logo} alt="Logo" className="w-48 lg:w-64" />
            </div>
          </div>
        </div>

        {/* Right Side */}
        <div className="w-full lg:w-1/2 bg-white flex items-start justify-center pt-4 sm:pt-6 px-4 sm:px-6 lg:px-10">
          <div className="w-full max-w-md">
            <h2 className="text-3xl sm:text-4xl lg:text-[45px] font-bold text-blue-900 mb-4 sm:mb-6 text-center font-inter">
              Create Student !
            </h2>

            <form className="space-y-4 sm:space-y-6" onSubmit={handleSubmit}>
              {/* Inputs (Keep exactly as your previous code) */}
              <div>
                <label className="block text-sm font-medium text-gray-700 font-inter mb-1">
                  First Name
                </label>
                <input
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  className={`w-full px-3 py-3 border ${
                    errors.first_name ? "border-red-500" : "border-gray-300"
                  } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  required
                />
                {errors.first_name && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.first_name}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 font-inter mb-1">
                  Last Name
                </label>
                <input
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  className={`w-full px-3 py-3 border ${
                    errors.last_name ? "border-red-500" : "border-gray-300"
                  } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  required
                />
                {errors.last_name && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.last_name}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 font-inter mb-1">
                  Mobile Number
                </label>
                <div className="relative">
                  <input
                    type="tel"
                    name="mobile_number"
                    value={formData.mobile_number}
                    onChange={handleChange}
                    maxLength="10"
                    className={`w-full px-3 py-3 pl-10 border ${
                      errors.mobile_number
                        ? "border-red-500"
                        : "border-gray-300"
                    } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    required
                  />
                  <MdPhone className="absolute left-3 top-2/4 -translate-y-1/2 text-gray-400 text-xl" />
                </div>
                {errors.mobile_number && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.mobile_number}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 font-inter mb-1">
                  Email
                </label>
                <div className="relative">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className={`w-full px-3 py-3 pl-10 border ${
                      errors.email ? "border-red-500" : "border-gray-300"
                    } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    required
                  />
                  <MdEmail className="absolute left-3 top-2/4 -translate-y-1/2 text-gray-400 text-xl" />
                </div>
                {errors.email && (
                  <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 font-inter mb-1">
                  Password
                </label>
                <div className="relative">
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute left-3 top-2/4 -translate-y-1/2 cursor-pointer text-gray-400 text-xl"
                  >
                    {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                  </span>
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    className={`w-full px-3 py-3 pl-10 border ${
                      errors.password ? "border-red-500" : "border-gray-300"
                    } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    required
                  />
                </div>
                {errors.password && (
                  <p className="text-red-500 text-sm mt-1">{errors.password}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 font-inter mb-1">
                  Confirm Password
                </label>
                <div className="relative">
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute left-3 top-2/4 -translate-y-1/2 cursor-pointer text-gray-400 text-xl"
                  >
                    {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                  </span>
                  <input
                    type={showPassword ? "text" : "password"}
                    name="confirm_password"
                    value={formData.confirm_password}
                    onChange={handleChange}
                    className={`w-full px-3 py-3 pl-10 border ${
                      errors.confirm_password
                        ? "border-red-500"
                        : "border-gray-300"
                    } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    required
                  />
                </div>
                {errors.confirm_password && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.confirm_password}
                  </p>
                )}
              </div>


           <div className="flex items-start gap-2 mt-4">
                <input
                  id="terms"
                  type="checkbox"
                  checked={isTermsAccepted}
                  onChange={(e) => setIsTermsAccepted(e.target.checked)}
                  className="w-4 h-4 mt-1 border-gray-300 rounded text-blue-900 focus:ring-blue-500 cursor-pointer"
                />
                <label
                  htmlFor="terms"
                  className="text-sm text-gray-600 font-inter"
                >
                  I agree to the{" "}
                  <button
                    type="button"
                    onClick={() => setShowTermsModal(true)}
                    className="text-blue-900 font-bold hover:underline bg-transparent border-none p-0 cursor-pointer"
                  >
                    Terms and Conditions
                  </button>
                </label>
              </div>










         <button
                type="submit"
                disabled={isLoading || !isTermsAccepted}
                className={`w-full h-12 sm:h-12 text-white font-semibold rounded-lg shadow-md transition duration-200 font-inter flex items-center justify-center ${
                  isLoading || !isTermsAccepted
                    ? "bg-gray-400 cursor-not-allowed" // Disabled Style
                    : "bg-blue-900 hover:bg-blue-800" // Enabled Style
                }`}
              >
                {isLoading ? (
                  <div className="flex items-center gap-2">
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Processing...
                  </div>
                ) : (
                  "NEXT"
                )}
              </button>
            </form>

            <p className="mt-6 text-sm text-center text-gray-600 font-inter mb-4">
              Not a member?{" "}
              <a
                href="/student-login"
                className="text-blue-900 font-medium hover:underline"
              >
                login
              </a>
            </p>
          </div>
        </div>
      </div>
      <ToastContainer position="top-center" autoClose={3000} />

          {showTermsModal && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-lg relative flex flex-col max-h-[85vh]">
            {/* Modal Header */}
            <div className="flex justify-between items-center p-4 border-b">
              <h3 className="text-xl font-bold text-blue-900">
                Terms and Conditions
              </h3>
              <button
                onClick={() => setShowTermsModal(false)}
                className="text-gray-500 hover:text-red-500 transition-colors"
              >
                <MdClose size={24} />
              </button>
            </div>
            {/* Modal Body (Scrollable) */}
            <div className="p-6 overflow-y-auto">
              <p className="text-gray-700 text-sm mb-4">
                <strong>1. Introduction</strong>
                <br />
                Welcome to our platform. By accessing or using our website, you
                agree to be bound by these terms.
              </p>
              <p className="text-gray-700 text-sm mb-4">
                <strong>2. User Obligations</strong>
                <br />
                You agree to provide accurate information during registration
                and maintain the security of your account credentials.
              </p>
              <p className="text-gray-700 text-sm mb-4">
                <strong>3. Privacy Policy</strong>
                <br />
                Your personal data is handled according to our Privacy Policy.
                We do not share your details without consent.
              </p>
              <p className="text-gray-700 text-sm mb-4">
                <strong>4. Account Termination</strong>
                <br />
                We reserve the right to suspend or terminate your account if you
                violate these terms.
              </p>
              <p className="text-gray-700 text-sm">
                (This is a sample text. Please replace with your actual terms.)
              </p>
            </div>
            {/* Modal Footer */}
            <div className="p-4 border-t flex justify-end">
              <button
                onClick={() => {
                  setShowTermsModal(false);
                  setIsTermsAccepted(true); // Auto check when they click "I Understand"
                }}
                className="bg-blue-900 text-white px-4 py-3 rounded-lg hover:bg-blue-800 transition"
              >
                I Understand & Agree
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentCreate;
